import { inject, InjectionKey } from 'vue';
import { ReportApiService } from './reportApiService';

export const REPORT_API_KEY: InjectionKey<ReportApiService> = Symbol('ReportApiService');

export function useReportApi(): ReportApiService {
	const service = inject<ReportApiService>(REPORT_API_KEY);
	if (!service) throw new Error('ReportApiService not provided');
	return service;
}
